import React, {
  createContext, useEffect, useMemo, useState,
} from 'react';
import { getInfoContentService } from '../../services/customer/infoContentServices';

export const TranslationContext = createContext({
  currentLanguage: localStorage.getItem('lang') || 'ka',
  setCurrentLanguage: () => {},
  configInfo: {
    countryCode: 'GE',
  },
  translatedNotifications: {},
});

const params = new URLSearchParams(window.location.search);
const lang = params.get('lang');

export function TranslationContextProvider({ children, configInfo }) {
  const [currentLanguage, setCurrentLanguage] = useState(localStorage.getItem('lang') || 'ka');
  const [translatedNotifications, setTranslatedNotifications] = useState({});

  const changeCurrentLanguage = (code) => {
    setCurrentLanguage(code);

    localStorage.setItem('lang', code);
  };

  useEffect(() => {
    if (lang) changeCurrentLanguage(lang);

    (async () => {
      const notifications = await getInfoContentService({ type: 'notifications' });
      try {
        if (notifications.status === 'success') {
          setTranslatedNotifications(JSON.parse(notifications.data.content || '{}'));
        }
      } catch {
        setTranslatedNotifications({});
      }
    })();
  }, []);

  const values = useMemo(() => ({
    currentLanguage,
    setCurrentLanguage: changeCurrentLanguage,
    configInfo,
    translatedNotifications,
  }), [currentLanguage, translatedNotifications]);

  return (
    <TranslationContext.Provider value={values}>
      {children}
    </TranslationContext.Provider>
  );
}
